(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['./lib/patchWorker'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(require('./lib/patchWorker'));
    } else {
        root.GameDataPatch = factory(root.GameDataPatchWorker);
    }
})(this, function (PatchWorker) {
    'use strict';
    var STRING = 'string';
    /**
     * Diff match patch wrapper class for use with game data
     * @param {[type]} base [description]
     */
    function GameDataPatch (base) {
        if (typeof base === STRING) {
            this.data = JSON.parse(base);
        } else {
            this.data = base;
        }
        this.patchWorker = new PatchWorker(this);
    };

    /**
     * Apply a set of text diffs (patches) and verify the result is parsable
     * If the patch process fails, success will be false and data will be the unpatched
     * object.
     * @param  {mixed} diffs Diff or array of diffs to be applied to the current
     *                       data set
     * @return {object}      Response object containing a success flag and the patched data
     */
    GameDataPatch.prototype.patch = function (diffs) {
        var patched = null;
        try {
            patched = this.patchWorker.patch(diffs);
        } catch (err) {
            console && console.error('patch worker error', err);
        }
        return this.verifyPatch(patched);
    };

    /**
     * @NOTE  not functional after switch to json-patch... need to ues an alternate lib for this
     * Create a diff string against the previous set of data.
     *
     * @param  {mixed} newData  JSON object or string of new data to diff against the previous
     *                          data set
     * @return {object}         Response object containing a diff key/val
     */
    GameDataPatch.prototype.diff = function (newData) {
        return newData;
        var newDataString = (typeof newData === STRING) ? newData : JSON.stringify(newData);

        return this.patchWorker.diff(newDataString);
    };

    /**
     * Verify that a patch procedure mostly succeded and the resulting
     * string can be parse back to json.
     * @todo Might need to make this verification a little tigher somehow.
     *       Unfortunately, the errors output
     * @param  {object}  patched Resulting json object from a patch operation.
     * @return {object}         Response object containg the data and a success flag
     */
    GameDataPatch.prototype.verifyPatch = function (patched) {
        var success = true,
            patchedData;

        if (patched) {
            success = true;
            this.data = patched;
        } else {
            success = false;
        }

        return {
            success: success,
            data: this.data
        };
    };

    return GameDataPatch;
});
